import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalClose,
  Label,
  ModalPortal,
  Button
} from '@sopranodesign/pulse-components';

import { useUploadFile, useFileSource } from '../../../hooks/index';
import { FileProvider } from '../../../Providers/index';
import FileDetails from '../../FileDetails';

const CreateDocument = ({ queryKey }) => {
  const [show, setShow] = useState(false);

  const source = useFileSource();

  const { mutate, isLoading } = useUploadFile(queryKey, {
    onSuccess: () => {
      setShow(false);
    }
  });

  const handleSubmit = form => {
    mutate({
      endpoint: queryKey,
      source_id: source.source.id,
      type: 'document',
      ...form
    });
  };

  const handleShowUpload = () => {
    setShow(true);
  };

  const handleHideUpload = () => {
    setShow(false);
  };

  return (
    <>
      <Button
        icon="plus"
        variant="primary"
        onClick={handleShowUpload}
        disabled={!source}>
        New Document
      </Button>
      {show && (
        <ModalPortal>
          <ModalContainer>
            <ModalContent>
              <ModalHeader>
                <Label mb={false}>Upload document</Label>
                <ModalClose onClick={handleHideUpload} />
              </ModalHeader>
              <FileProvider>
                <FileDetails loading={isLoading} onSubmit={handleSubmit} />
              </FileProvider>
            </ModalContent>
          </ModalContainer>
        </ModalPortal>
      )}
    </>
  );
};

CreateDocument.propTypes = {
  queryKey: PropTypes.string.isRequired
};

export default CreateDocument;
